import { IModuleMetaData } from "./company-module";

export class ExtraUsersMetaData {
	private metadata:IModuleMetaData;

	private constructor(metadata:IModuleMetaData){
		this.metadata = metadata;
	}

	public static create(metadata:IModuleMetaData):ExtraUsersMetaData{
		return new ExtraUsersMetaData(metadata || {});
	}

	public getExtraUsers():number{
		return parseInt(this.metadata["extra-users"] || "0") || 0;
	}

	public setExtraUsers(count:number):void {
		this.metadata["extra-users"] = `${count}`;
	}
}